import * as React from 'react';
const ModalDialogVariantColorContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  ModalDialogVariantColorContext.displayName = 'ModalDialogVariantColorContext';
}
export default ModalDialogVariantColorContext;